var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_vm._m(0),_c('div',{staticClass:"copyright text-center"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":""}},[_vm._v(_vm._s(_vm.WhiteLabellingTitle()))]),_vm._v(", powered by @tabnova ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul')])
}]

export { render, staticRenderFns }